module.exports = __webpack_public_path__ + "static/img/logo_3 - 副本 (2).be4e21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_3 - 副本 (2).png
// module id = h4hz
// module chunks = 0